import React from 'react';
import randomstring from 'uuid/v4';

import Message from './Message';

class ListMessage extends React.Component {


    render() {
        const { messages, search, somefilter, filter } = this.props;
        return (
            <div className={'flex_full_column'}>
                {
                    messages
                        .filter((f) =>
                            (!search || (f.asunto && f.asunto.toLowerCase().indexOf(search.toLowerCase()) >= 0)) &&
                            (!somefilter ||
                                (
                                    (!filter.urgent || f.prioridad === 1) &&
                                    (!filter.unreaded || f.estado === 0) &&
                                    (!filter.from || f.enviada >= filter.from.replace('T', ' ')) &&
                                    (!filter.to || f.enviada <= filter.to.replace('T', ' ')) &&
                                    (!filter.fromLimit || f.limite >= filter.fromLimit.replace('T', ' ')) &&
                                    (!filter.toLimit || f.limite <= filter.toLimit.replace('T', ' ')) &&
                                    (filter.selectedroles.length === 0 || filter.selectedroles.some((s) => s.id === f.idEnviadapor && s.type === 'user'))
                                )
                            )
                        )
                        .sort((a, b) => a.id < b.id ? 1 : -1)
                        .map((m) => {
                            return (<Message {...this.props} key={randomstring()} item={m} />);
                        })
                }
            </div>
        );
    }
}

export default ListMessage;



// WEBPACK FOOTER //
// ./src/components/complex/communications/ListMessage.js